export const supplierPage = {
  message: 'OK',
  data: {
    results: [
      {
        id: '1',
        name: 'Nuovo',
        code: 'NVO',
        createdAt: '26/01/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      },
      {
        id: '2',
        name: 'Apple',
        code: 'APL',
        createdAt: '26/01/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      },
      {
        id: '3',
        name: 'Equality',
        code: 'EQU',
        createdAt: '26/01/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      },
      {
        id: '4',
        name: 'Otros',
        code: 'OTR',
        createdAt: '26/01/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      },
      {
        id: '5',
        name: 'Automotriz',
        code: 'AUT',
        createdAt: '26/01/2026',
        updatedAt: null,
        createdBy: null,
        updatedBy: null
      }
    ],
    total: [],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 4,
      range: [1],
      count: 4,
      pages: 1,
      total: 4,
      limit: 10
    }
  },
  status: 200
}

export const supplierCatalog = {
  message: 'OK',
  data: [
    {
      id: '2',
      label: 'Apple'
    },
    {
      id: '3',
      label: 'Equality'
    },
    {
      id: '1',
      label: 'Nuovo'
    },
    {
      id: '4',
      label: 'Otros'
    },
    {
      id: '5',
      label: 'Automotriz'
    }
  ],
  status: 200
}
